import { getUrlParamByName } from '@/commons/tools';

/**
 * 优惠券相关页面 端上通过url带的channel_type枚举值
 * @docs https://huolala.feishu.cn/docs/doccnw04A8WYn7JHg9OXsKB3XDd
 */
export const channelTypeMap = {
  XL_ANDROID: '1001', // 小拉安卓
  XL_IOS: '1002', // 小拉IOS
  XL_WX_MINI: '1003', // 小拉微信
  HUOYUN_ANDROID: '1', // 货运安卓
  HUOYUN_IOS: '2', // 货运IOS
  HUOYUN_WX_MINI: '10', // 货运微信小程序
  HUOYUN_M_PASS: '4', // 货运mPass
  HUOYUN_M_WEB: '5', // 货运M站
  HUOYUN_BAIDU_MINI: '12', // 货运百度小程序
  HUOYUN_QUICK_APP: '13', // 货运快应用
  HUOYUN_ALIPAY_MINI: '14', // 货运支付宝小程序
  // COMPANY_ANDROID: '7', // 货运企业安卓
  // COMPANY_IOS: '8', // 货运企业IOS
  // COMPANY_WX_MINI: '9', // 货运企业微信小程序
  COMPANY_WBE: '7', // 企业web
  COMPANY_ANDROID: '8'  , // 货运企业安卓 // 
  COMPANY_IOS: '9', // 货运企业IOS
  COMPANY_WX_MINI: '11', // 货运企业微信小程序
  COMPANY_H5: '16', // 企业H5
  COMPANY_HARMONY: '19', // 企业鸿蒙H5
  MOVE_ANDROID: '32', // 货运搬家安卓
  MOVE_IOS: '31', // 货运搬家IOS
  MOVE_WX_MINI: '30', // 货运微信搬家小程序
  MOVE_ALIPAY_MINI: '34', // 货运搬家支付宝小程序
  MOVE_M_WEB: '35', // 货运搬家M站
  MOVE_MEITUAN_MINI: '42', // 搬家美团小程序
  HUOYUN_DOUYIN: '17', // 货运抖音小程序
  HUOYUN_HONGMENG: '18', // 货运鸿蒙
  MOVE_HONGMENG: '37', // 搬家鸿蒙
  MOVE_KUAISHOU: '38', // 搬家快手小程序
  MOVE_DOUYIN: '39', // 搬家抖音小程序
};

// 是否处于货拉拉app中
export function isHllAppHost() {
  return !!(isHuoYunAppHost() || isMoveAppHost());
}

// ---- begin 货运 -----
/**
 * 是否处于货运App中
 */
export function isHuoYunAppHost() {
  const channel_type = getUrlParamByName('channel_type');
  return [channelTypeMap.HUOYUN_ANDROID, channelTypeMap.HUOYUN_IOS, channelTypeMap.HUOYUN_HONGMENG].includes(String(channel_type))
}

// 是否处货运微信小程序中
export function isHuoYunWxMiniHost() {
  return getUrlParamByName('channel_type') == channelTypeMap.HUOYUN_WX_MINI;
}

/**
 *
 * 是否处于货运支付宝小程序中
 */
export function isHuoYunAlipayMiniHost() {
  return getUrlParamByName('channel_type') == channelTypeMap.HUOYUN_ALIPAY_MINI;
}

// 是否处于货运百度小程序
export function isHuoYunBaiduMiniHost() {
  return getUrlParamByName('channel_type') == channelTypeMap.HUOYUN_BAIDU_MINI;
}

// 是否处于货运快应用
export function isHuoYunQuickAppHost() {
  return getUrlParamByName('channel_type') == channelTypeMap.HUOYUN_QUICK_APP;
}

// 是否处于货运M站
export function isHuoYunMWebHost() {
  return getUrlParamByName('channel_type') == channelTypeMap.HUOYUN_M_WEB;
}

// ---- end 货运 -----

// ---- begin 搬家 -----
// 是否处于货拉拉app搬家业务线
export function isMoveAppHost() {
  const channel_type = getUrlParamByName('channel_type');
  // return channel_type == channelTypeMap.MOVE_ANDROID || channelTypeMap.MOVE_IOS;
  return [channelTypeMap.MOVE_ANDROID, channelTypeMap.MOVE_IOS, channelTypeMap.MOVE_HONGMENG].includes(String(channel_type));
}

// // 是否处于搬家微信小程序中
export function isMoveWxMiniHost() {
  return getUrlParamByName('channel_type') == channelTypeMap.MOVE_WX_MINI;
}

// // 是否处于搬家支付宝小程序中
export function isMoveAlipayMiniHost() {
  return getUrlParamByName('channel_type') == channelTypeMap.MOVE_ALIPAY_MINI;
}

// 是否处于搬家m站
export function isMoveMWebHost() {
  return getUrlParamByName('channel_type') == channelTypeMap.MOVE_M_WEB;
}

// 是否处于搬家快手
export function isMoveKuaiShouHost() {
  return getUrlParamByName('channel_type') == channelTypeMap.MOVE_KUAISHOU;
}

// 是否处于搬家抖音
export function isMoveDouYinHost() {
  return getUrlParamByName('channel_type') == channelTypeMap.MOVE_DOUYIN;
}
// ---- end 搬家 -----
